import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';

import { DevCalendarsVenue } from './DevCalendarsVenue';
import { DevEarlyFeature } from './DevEarlyFeature';
import { DevImpactQuestionsVenue } from './DevImpactQuestionsVenue';
import { DevImportImage } from './DevImportImage';
import { DevNewFormESSEnv } from './DevNewFormESSEnv';
import { DevOnTourArrows } from './DevOnTourArrows';
import { DevPlayground } from './DevPlayground';
import { DevProjectCard } from './DevProjectCard';
import { DevUIScoreComponents } from './DevUIScoreComponents';
import { DevForms } from './forms/DevForms';
import { LabFieldWith2Input } from './LabFieldWith2Input';
import { DevMain } from './main/Main';

const STARTING_TAB = 0;

export function Dev() {
  const [tabValue, setTabValue] = useState(STARTING_TAB);

  const tabs = [
    { label: 'Main', component: <DevMain /> },
    { label: 'Forms', component: <DevForms /> },
    { label: 'Early feature', component: <DevEarlyFeature /> },
    { label: 'New form ESS Env', component: <DevNewFormESSEnv /> },
    { label: 'Lab: field with 2 inputs', component: <LabFieldWith2Input /> },
    { label: 'UI score components', component: <DevUIScoreComponents /> },
    { label: 'Project card', component: <DevProjectCard /> },
    { label: 'Playground', component: <DevPlayground /> },
    {
      label: 'CO2 / ESS / ENV questions for venue',
      component: <DevImpactQuestionsVenue />,
    },
    { label: 'calendar compo for venue', component: <DevCalendarsVenue /> },
    { label: 'import image', component: <DevImportImage /> },
    { label: 'on tour arrows', component: <DevOnTourArrows /> }, // 11
  ];

  return (
    <Box>
      <Typography sx={{ fontSize: '2rem', textAlign: 'center' }}>
        👨‍💻 Hidden dev page 👨‍💻
      </Typography>
      <Stack sx={{ flexDirection: 'row', gap: 2 }}>
        <Box>
          <Tabs
            value={tabValue}
            onChange={(e, value) => setTabValue(value)}
            orientation="vertical"
            scrollButtons="auto"
            sx={{ width: 250, borderRight: 1, borderColor: 'divider' }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
        </Box>
        <Box sx={{ m: 2, px: 2, border: 1, borderColor: '#AA4322' }}>
          <Box>{tabs[tabValue].component}</Box>
        </Box>
      </Stack>
    </Box>
  );
}
